/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Subtitle_No_Profile_MessageInputs */

const en_iframe_remote_subtitle_no_profile_message = /** @type {(inputs: Iframe_Remote_Subtitle_No_Profile_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No profile or file extension provided.`)
};

const fr_iframe_remote_subtitle_no_profile_message = /** @type {(inputs: Iframe_Remote_Subtitle_No_Profile_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun profil ou extension de fichier fourni.`)
};

const de_iframe_remote_subtitle_no_profile_message = /** @type {(inputs: Iframe_Remote_Subtitle_No_Profile_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es wurde kein Profil oder keine Dateierweiterung angegeben.`)
};

const it_iframe_remote_subtitle_no_profile_message = /** @type {(inputs: Iframe_Remote_Subtitle_No_Profile_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun profilo o estensione di file forniti.`)
};

const ru_iframe_remote_subtitle_no_profile_message = /** @type {(inputs: Iframe_Remote_Subtitle_No_Profile_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Профиль и расширение файла не указаны.`)
};

const es_iframe_remote_subtitle_no_profile_message = /** @type {(inputs: Iframe_Remote_Subtitle_No_Profile_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se proporcionó ningún perfil ni extensión de archivo.`)
};

const zh_cn2_iframe_remote_subtitle_no_profile_message = /** @type {(inputs: Iframe_Remote_Subtitle_No_Profile_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未提供配置文件或文件扩展名。`)
};

const ja_iframe_remote_subtitle_no_profile_message = /** @type {(inputs: Iframe_Remote_Subtitle_No_Profile_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロファイルまたはファイル拡張子が指定されていません。`)
};

const hi_iframe_remote_subtitle_no_profile_message = /** @type {(inputs: Iframe_Remote_Subtitle_No_Profile_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई प्रोफ़ाइल या फ़ाइल एक्सटेंशन प्रदान नहीं किया गया है।`)
};

const pt_pt2_iframe_remote_subtitle_no_profile_message = /** @type {(inputs: Iframe_Remote_Subtitle_No_Profile_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum perfil ou extensão de arquivo foi fornecido.`)
};

/**
* | output |
* | --- |
* | "No profile or file extension provided." |
*
* @param {Iframe_Remote_Subtitle_No_Profile_MessageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_subtitle_no_profile_message = /** @type {((inputs?: Iframe_Remote_Subtitle_No_Profile_MessageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Subtitle_No_Profile_MessageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iframe_remote_subtitle_no_profile_message(inputs)
	if (locale === "de") return de_iframe_remote_subtitle_no_profile_message(inputs)
	if (locale === "it") return it_iframe_remote_subtitle_no_profile_message(inputs)
	if (locale === "ru") return ru_iframe_remote_subtitle_no_profile_message(inputs)
	if (locale === "es") return es_iframe_remote_subtitle_no_profile_message(inputs)
	if (locale === "zh-CN") return zh_cn2_iframe_remote_subtitle_no_profile_message(inputs)
	if (locale === "ja") return ja_iframe_remote_subtitle_no_profile_message(inputs)
	if (locale === "hi") return hi_iframe_remote_subtitle_no_profile_message(inputs)
	if (locale === "pt-PT") return pt_pt2_iframe_remote_subtitle_no_profile_message(inputs)
	return en_iframe_remote_subtitle_no_profile_message(inputs)
});